import PropTypes from 'prop-types'

import { Warning } from 'basic-components/icons'

const WarningMessage = ({ children }) => (
  <div className="data-lake__group-dialog__advanced__dynamic-validation__warning">
    <div className="data-lake__group-dialog__advanced__dynamic-validation__warning__icon">
      <Warning
          bgColor="orange-base"
          color="white-base"
          height={16}
          width={16}
      />
    </div>
    <div className="data-lake__group-dialog__advanced__dynamic-validation__warning__text">
      {children}
    </div>
  </div>
)

WarningMessage.propTypes = {
  children: PropTypes.node.isRequired
}

export default WarningMessage
